<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import clientDetails from "@/components/clients/clientDetails.vue";

/**
 * Starter component
 */
export default {
    page: {
        title: "Client Details",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader, clientDetails },
    data() {
        return {
            title: "Client Details",
            items: [
                {
                    text: "Client Details",
                    active: true,
                },
            ],
        };
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <clientDetails repUser/>
    </Layout>
</template>
